<div class="with-side-menu">
  @if (layout === 'full') {
    <ag-header></ag-header>
  }

  <!-- PAGE -->
  <router-outlet></router-outlet>
  <!-- /PAGE -->

  <ag-alerts #alertsComponent [duration]="5000"></ag-alerts>
</div>

<div kendoDialogContainer></div>
